import { render, staticRenderFns } from "./InformationWrapper.vue?vue&type=template&id=33618598"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33618598')) {
      api.createRecord('33618598', component.options)
    } else {
      api.reload('33618598', component.options)
    }
    module.hot.accept("./InformationWrapper.vue?vue&type=template&id=33618598", function () {
      api.rerender('33618598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inforationCards/InformationWrapper.vue"
export default component.exports